module.exports = __webpack_public_path__ + "img/search_address_house_magnifier.b605bceb.png";